module.exports = __webpack_public_path__ + "img/Bingo_Asset_Info_Web1.6f9643d0.png";